import {dateTime, duration} from "services/date";
import {Sponsorship} from "types/Sponsorship";
import deserializeSponsorshipTier from "services/ngage/deserializers/sponsorship-tier";

/**
 * Transform the given sponsorship by deserializing object properties
 *
 * @internal
 * @param sponsorship
 */
export default function deserializeSponsorship(sponsorship: any): Sponsorship {
    sponsorship.tier = deserializeSponsorshipTier(sponsorship.tier)
    sponsorship.starts_at = dateTime(sponsorship.starts_at)
    sponsorship.ends_at = dateTime(sponsorship.ends_at)
    sponsorship.duration = duration(sponsorship.duration.iso)
    sponsorship.created_at = dateTime(sponsorship.created_at)
    sponsorship.updated_at = dateTime(sponsorship.updated_at)

    return sponsorship;
}